import { useState, useEffect } from "react";
import { useFollowingNichesQuery, useGifNichesQuery } from "queries";
import { CheckboxOption, calculateNicheFields } from "./helpers";

export const useNicheData = (gifId: string) => {
  const [nicheFields, setNicheFields] = useState<CheckboxOption[]>([]);
  const [error, setError] = useState<boolean>(false);

  const {
    data: followingNiches,
    isSuccess: followingNichesSuccess,
    error: followingNichesError
  } = useFollowingNichesQuery({ previews: false });

  const {
    data: gifNiches,
    isSuccess: gifNichesSuccess,
    error: gifNichesError
  } = useGifNichesQuery(gifId, { refetchOnMount: true, cacheTime: 0 });

  const handleSetNicheFiled = (fields: CheckboxOption[]) => {
    setNicheFields(fields);
  };

  useEffect(() => {
    if (followingNichesSuccess && gifNichesSuccess && gifNiches && followingNiches) {
      const updatedNicheFields = calculateNicheFields(
        followingNiches.niches,
        gifNiches.niches
      );

      handleSetNicheFiled(updatedNicheFields);
    }

    if (gifNichesError || followingNichesError) {
      setError(true);
    }
  }, [
    followingNichesSuccess,
    gifNichesSuccess,
    followingNichesError,
    gifNichesError,
    followingNiches,
    gifNiches,
  ]);

  return {
    nicheFields,
    handleSetNicheFiled,
    error
  };
};
